export default "__VITE_ASSET__qNkzjvxE__"